import { EffectHandler } from "../types/editor"

const localSpeedHandler: EffectHandler = {
    // 添加
    addEffect(editor, selection, value) {
        editor.addcontainEffectHtml({
            range: selection.range,
            effectType: 'localSpeed',
            effectUIType:'speed',
            idName: 'speedHover',
            param:{speed:value,speedVal:value+"x"}
        })
    },
    // 修改
    modifyEffect(editor, selection, value) { },
    // 删除
    removeEffect(editor, selection) { },
}
export default localSpeedHandler